/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Vue from 'vue'
import { store } from '../store'

export const actions = {
    loadClientsBackConnection() {
        Vue.http.options.root = process.env.VUE_APP_API_BASE_URL
        Vue.http.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`
        Vue.http.headers.common['Accept'] = 'application/json'
    },
    async login({commit}, payload) {

        commit('UI/loaders/changeLoginLoader', 'red', { root: true })

        return new Promise(async (resolve, reject) => {
            Vue.http.options.root = process.env.VUE_APP_API_BASE_URL

        let params = {
            'grant_type': process.env.VUE_APP_GRANT_TYPE,
            'client_id': process.env.VUE_APP_CLIENT_ID,
            'client_secret': process.env.VUE_APP_CLIENT_SECRET_KEY,
            'username': payload.credentials.username,
            'password': payload.credentials.password
        }

        let options = {
            emulateJSON: true,
            headers: {
              'Content-Type': 'multipart/form-data',
              'accept': 'application/json'
            }
          }

        await Vue.http.post('oauth/token', params, options)
            .then(response => {
                localStorage.setItem('token', response.body.access_token)
                commit('setLoginState', true)
                commit('UI/loaders/changeLoginLoader', false, { root: true })
                resolve(response)
            })
            .catch(err => {
                commit('setLoginState', false)
                commit('UI/loaders/changeLoginLoader', false, { root: true })
                reject(err)
            })
        })
    },
    logout({commit}, payload) {
        localStorage.removeItem('selectedBranches')
        localStorage.removeItem('sucursal')
        localStorage.removeItem('token')
        commit('setDashboardWasLoaded', false)
        commit('setLoginState', false)
    },
    verifyLoginState({commit}, payload) {
        commit('setLoginState', localStorage.getItem('token') ? true : false)
    },
    getInfo({commit}, payload) {

        commit('UI/loaders/changeLoader', true, { root: true })

        return new Promise( async (resolve, reject) => {

        // Setup connection with backend
        store.dispatch('userModule/loadClientsBackConnection', { root: true })

        await Vue.http.get('api/get-user-client-information')
            .then(response => {
                commit('setInfo', response.body.data)
                commit('UI/loaders/changeLoader', false, { root: true })
                resolve(response.body)
            })
            .catch(err => {
                commit('UI/loaders/changeLoader', false, { root: true })
                reject(err)
            })
        })
    },
    getBranches({commit}, payload) {

        commit('UI/loaders/changeBranchesLoader', true, { root: true })

        return new Promise( async (resolve, reject) => {
            // Setup connection with backend
        store.dispatch('userModule/loadClientsBackConnection', { root: true })

        await Vue.http.get('api/get-office-sites')
            .then(response => {
                commit('setBranches', response.body.data)
                commit('UI/loaders/changeBranchesLoader', false, { root: true })
                resolve(response.body)
            })
            .catch(err => {
                commit('UI/loaders/changeBranchesLoader', false, { root: true })
                reject(err)
            })
        })
    },
    getActiveTrips({commit}, payload) {

        commit('UI/loaders/changeTableLoader', true, { root: true })

        return new Promise( async (resolve, reject) => {

        // Setup connection with backend
        store.dispatch('userModule/loadClientsBackConnection', { root: true })

        await Vue.http.get('api/get-client-active-trips', {params: {
            filter_type: payload.sucursalId,
            branches: payload.branches
        }})
            .then(response => {
                commit('setActiveTrips', response.body.data)
                commit('UI/loaders/changeTableLoader', false, { root: true })
                resolve(response.body)
            })
            .catch(err => {
                commit('UI/loaders/changeTableLoader', false, { root: true })
                reject(err)
            })
        })
    },
    getFinalizedTrips({commit}, payload) {

        commit('UI/loaders/changeFinalizedTableLoader', true, { root: true })

        return new Promise( async (resolve, reject) => {

        // Setup connection with backend
        store.dispatch('userModule/loadClientsBackConnection', { root: true })

        await Vue.http.get('api/get-client-active-trips', {params: {
            filter_type: payload.sucursalId,
            branches: payload.branches,
            finished: true,
            perPage: payload.perPage,
            page: payload.page
        }})
            .then(response => {
                commit('setFinalizedTrips', response.body.data.data)
                commit('setFinalizedTripsPagination', response.body.data)
                commit('UI/loaders/changeFinalizedTableLoader', false, { root: true })
                resolve(response.body)
            })
            .catch(err => {
                commit('UI/loaders/changeFinalizedTableLoader', false, { root: true })
                reject(err)
            })
        })
    },
    changeDashboardWasLoaded({commit}, payload) {
        commit('setDashboardWasLoaded', payload)
    }
}
